import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ResponseTemplate from './ResponseTemplate';

const ViewResponsePopup = ({ open, onClose, surveyId, clientId }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{ '& .MuiDialog-paper': { maxHeight: '80vh', overflowY: 'auto' } }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(5px)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Adds a semi-transparent overlay for better contrast
        },
      }}
    >
      <DialogTitle sx={{ fontFamily: "'Mulish', sans-serif", fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Survey Responses
        <IconButton
          onClick={onClose}
          sx={{ color: '#ffffff' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {surveyId && clientId ? (
          <ResponseTemplate surveyId={surveyId} clientId={clientId} />
        ) : (
          <Typography color="error">
            Invalid survey or client ID. Please try again.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

ViewResponsePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ViewResponsePopup;